export const NewInteraction = {
  CALL: 'CALL',
  MAIL: 'MAIL',
  SMS: 'SMS',
} as const

export type NewInteractionValues = (typeof NewInteraction)[keyof typeof NewInteraction]
